var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgNumber = function SvgNumber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.089 20.454a1.01 1.01 0 0 1-.996-1.172l2.532-15.436a1.01 1.01 0 0 1 1.992.327l-2.532 15.436a1.01 1.01 0 0 1-.996.845Zm-7.887-4.67a1.023 1.023 0 1 1 0-2.045h11.155a1.023 1.023 0 0 1 0 2.045H6.202Zm1.75 4.67a1.01 1.01 0 0 1-.995-1.172L9.489 3.846a1.01 1.01 0 0 1 1.992.327L8.948 19.609a1.01 1.01 0 0 1-.995.845ZM7.218 9.716a1.023 1.023 0 0 1 0-2.046h11.155a1.023 1.023 0 0 1 0 2.046H7.217Z",
    fill: "#262D38"
  })));
};

export default SvgNumber;